import request from '@/utils/request';

// 企业下拉
export const getSelectEnterpriseList = () => {
  return request({
    url: '/enterprise/getAllList',
    method: 'get'
  })
}